interface SanitizeOptions {
  trimStart?: boolean;
}

export const sanitizeTutorCaption = (text: string, options: SanitizeOptions = {}) => {
  const cleaned = text
    .replace(/\[INTERNAL_AURA_CONTROL\][\s\S]*?\[\/INTERNAL_AURA_CONTROL\]/gi, ' ')
    .replace(/\[COGNITIVE_DIRECTIVE\][^\n\r]*/gi, ' ')
    .replace(/\[\s*⚡\s*(?:SLOW|ERR|WRAP|NEXT)\s*\]/gi, ' ')
    .replace(/\b(?:Do not read this aloud|Next tutor behavior|Initialize session in mode)\b[^\n\r]*/gi, ' ')
    .replace(/\s+([,.!?;:])/g, '$1')
    .replace(/[ \t]{2,}/g, ' ');

  return options.trimStart === false ? cleaned : cleaned.trimStart();
};

export const appendTutorCaptionDelta = (currentText: string, delta: string) => {
  const cleanDelta = sanitizeTutorCaption(delta || '', { trimStart: currentText.length === 0 });
  if (!cleanDelta) return currentText;
  return `${currentText}${cleanDelta}`;
};
